import { makeStyles } from "@material-ui/core";

const useSelectStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    height: 30,
  },
  select: {
    "&:focus": {
      background: "transparent",
    },
  },
});

export default useSelectStyles;
